import type { Configuration } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-browser';

const azureClientId = import.meta.env.VITE_AZURE_CLIENT_ID as string | undefined;
const azureTenantId = import.meta.env.VITE_AZURE_TENANT_ID as string | undefined;

/**
 * Whether real Azure AD credentials are present. The MSAL provider is always
 * mounted (so the Microsoft and email/password flows can coexist), but when this
 * is false — e.g. local development with no Azure app — the Microsoft button is
 * hidden and MSAL is constructed with a harmless placeholder so it doesn't throw.
 */
export const isAzureConfigured = Boolean(azureClientId && azureTenantId);

const PLACEHOLDER_CLIENT_ID = '00000000-0000-0000-0000-000000000000';

export const msalConfig: Configuration = {
  auth: {
    clientId: azureClientId || PLACEHOLDER_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${azureTenantId || 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

export const tokenRequest = {
  scopes: [`api://${azureClientId || PLACEHOLDER_CLIENT_ID}/access_as_user`],
};
